<template>
  <div v-if="imgList['leftlist'].length || imgList['rightlist'].length">
    <ul :class="['sm-stills', showAllContent ? 'show' : '']">
      <li>
        <div
          v-for="(value, i) in imgList['leftlist']"
          :key="i"
          class="img-wrap"
        >
          <img
            v-lazy="$parent.getResizePicUrl(value.url, 200, 'auto', 200839)"
            alt
          >
        </div>
      </li>
      <li>
        <div
          v-for="(value, i) in imgList['rightlist']"
          :key="i"
          class="img-wrap"
        >
          <img
            v-lazy="$parent.getResizePicUrl(value.url, 200, 'auto', 200839)"
            alt
          >
        </div>
      </li>
      <div class="sm-stills-flow" />
    </ul>
    <div
      v-show="!showAllContent"
      class="sm-stills-show"
      @click="showContent"
    >
      <span>展开更多</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { singlePageClParams } from '../../common/js/util';

export default {
  data() {
    return {
      showAllContent: false,
    };
  },
  computed: {
    ...mapState('summary', ['itemData']),
    imgList() {
      const data = this.itemData;
      const ret = { leftlist: [], rightlist: [] };
      if (typeof data === 'undefined' || typeof data.photo === 'undefined') return ret;
      const photoList = data.photo;
      if (Object.prototype.hasOwnProperty.call(photoList, 'item_list') && photoList.item_list.length > 0) {
        // if(photoList.hasOwnProperty('item_list') && photoList.item_list.length > 0){
        const { item_list: itemList } = photoList;
        if (itemList && itemList.length > 0) {
          const list = [];
          for (const value of itemList) {
            list.push(this.getWandH(value));
          }
          return this.getImageData(list);
        }
      }
      return ret;
    },
  },
  mounted() {
    window.onload = function () {
      const eles = document.querySelectorAll('.sm-stills li');
      if (eles && eles.length) {
        const h1 = eles[0].offsetHeight || 0;
        const h2 = eles[1].offsetHeight || 0;
        if (h1 <= 390 && h2 <= 390) {
          document.getElementsByClassName('sm-stills-flow')[0].style.display = 'none';
          document.getElementsByClassName('sm-stills-show')[0].style.display = 'none';
        }
      }
    };
  },
  methods: {
    getWandH(str) {
      const data = {};
      data.isWgtH = false;
      data.url = str;
      if (str !== '' && str.indexOf('#') > 0) {
        const [, strFirst] = str.split('#');
        if (strFirst.indexOf('x') > 0) {
          const array = strFirst.split('x');
          if (array.length === 2) {
            [data.w, data.h] = array;
            if (Number(array[0]) > Number(array[1])) {
              // width > Height
              data.isWgtH = true;
            }
          }
        }
      }
      return data;
    },
    getImageData(list) {
      const llist = [];
      const rlist = [];
      if (list.length === 1) {
        llist.push(list[0]);
        list.splice(0, 1);
      }
      for (const v of list) {
        if (llist.length === 0 && v.isWgtH) {
          llist.push(v);
          list.splice(list.indexOf(v), 1);
        }
        if (rlist.length === 0 && !v.isWgtH) {
          rlist.push(v);
          list.splice(list.indexOf(v), 1);
        }
      }
      for (const value of list) {
        const lAcc = llist.reduce((acc, cur) => acc + Number(cur.h), 0);
        const rAcc = rlist.reduce((acc, cur) => acc + Number(cur.h), 0);
        if (lAcc <= rAcc) {
          // 填补高度
          llist.push(value);
        } else {
          rlist.push(value);
        }
      }
      return { leftlist: llist, rightlist: rlist };
    },
    showContent() {
      this.showAllContent = true;
      const clParams = singlePageClParams('still_showContent');
      this.$uigs.send(clParams);
    },
    getResizePicUrl(url, width, height, appid) {
      // 获取云图裁剪图片地址
      if (url === null || url === '') return '';
      const r = Math.floor(Math.random() * 4) + 1;
      let newurl = '';
      newurl = `https://img0${r}.sogoucdn.com/v2/thumb/resize/w/${width}/h/${height}/t/1/retype/ext/auto/q/75?appid=${appid}&url=${encodeURIComponent(url)}`;
      return newurl;
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.sm-stills {
  overflow: hidden;
  max-height: 393px;
  position: relative;

  .sm-stills-flow {
    position: absolute;
    height: 79px;
    bottom: 0;
    left: 0;
    width: 100%;

    background-image: -moz-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ffffff 90%);
    background-image: -webkit-gradient(
      linear,
      left top,
      left bottom,
      color-stop(0%, rgba(255, 255, 255, 0)),
      color-stop(90%, #ffffff)
    );
    background-image: -webkit-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ffffff 90%);
    background-image: -o-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ffffff 90%);
    background-image: -ms-linear-gradient(top, rgba(255, 255, 255, 0) 0%, #ffffff 90%);
    background-image: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, #ffffff 90%);
  }
}

.sm-stills.show {
  max-height: unset;
}
.sm-stills.show .sm-stills-flow {
  display: none;
}
.sm-stills li {
  width: 50%;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  float: left;
}

.sm-stills li:nth-child(odd) {
  padding-right: 1px;
}

.sm-stills li:nth-child(even) {
  padding-left: 1px;
}

.sm-stills .img-wrap {
  overflow: hidden;
  margin-bottom: 2px;
}

.sm-stills .img-wrap img {
  display: block;
  width: 100%;
}

.sm-stills-show {
  margin: 0 14px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: rgba(245, 245, 245, 1);
  border-radius: 3px;
  margin-top: 20px;

  span {
    font-size: 13px;
    color: rgba(34, 34, 34, 1);
    &:after {
      content: '';
      display: inline-block;
      @include arr(6px, 135deg, #222);
      margin-left: 6px;
      vertical-align: 3px;
    }
  }
}
</style>
